import { URL_FORMS } from '../store/api';

export async function sendMail(
  values: any,
  {
    preloader,
    success,
    failed,
  }: {
    preloader: { open: () => void; close: () => void };
    success: { open: () => void };
    failed: { open: () => void };
  },
): Promise<void> {
  if (!URL_FORMS) return;
  try {
    preloader.open();
    await fetch(URL_FORMS, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    preloader.close();
    success.open();
  } catch (error) {
    preloader.close();
    failed.open();
  }
}
